import React, { useState } from 'react';
import { IDocument } from '../Interfaces/IDocument';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import { useCreateBulkInvoices } from '../hooks/reactQuerys/InvoiceQueries';
import { InvoiceCreateDialogUpload } from './InvoiceCreateDialogUpload';
import { IInvoiceFullObject } from '../Interfaces/IInvoice';
import { DocumentPreviewDialog } from '../Document/DocumentAssistant/DocumentPreviewDialog';
import { InvoiceCreateDialogSelect } from './InvoiceCreateDialogSelect';
import { LoadingSpinner } from '../core/LoadingSpinner';
import { useAlert } from '../context/AlertContext';

interface IProps {
  refetchTrigger: Function;
}

export const InvoiceCreateDialog: React.FC<IProps> = ({ refetchTrigger }) => {
  const { showAlert } = useAlert();
  //
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [showUploadSeciton, setShowUploadSeciton] = useState(true);

  //
  const [invoiceObjects, setInvoiceObjects] = useState<IInvoiceFullObject[]>(
    []
  );
  const [selectedInvoice, setSelectedInvoice] = useState<number[]>([]);
  //
  const [previewObject, setPreviewObject] = useState<IDocument | null>(null);
  const [isOpenPreview, setisOpenPreview] = useState(false);
  //
  const { createBulkInvoices, isPendingCreateBulkInvoices } =
    useCreateBulkInvoices();
  const isPending = isPendingCreateBulkInvoices;

  const wrapperUploadedInv = (invArray: IInvoiceFullObject[]) => {
    setInvoiceObjects(invArray);
    setSelectedInvoice([
      ...invArray
        .filter(inv => inv.idLegalTransaction > 0)
        .filter(inv => inv.InvoiceNumber !== '')
        .map(x => x.idInvoice),
    ]);
  };

  const handleOpen = () => {
    setShowUploadSeciton(true);
    setInvoiceObjects([]);
    setSelectedInvoice([]);
    setIsOpenDialog(true);
  };
  const handleClose = () => {
    setIsOpenDialog(false);
  };

  const handleOpenPreview = (toPreview: IInvoiceFullObject) => {
    setPreviewObject({
      Created_at: toPreview.Created_at,
      FileName: toPreview.FileName,
      idDocument: -1,
      idDocumentDirectory: -1,
      idLegalTransaction: -1,
      idMIMEType: 1,
      isFromTemplate: false,
      perEmail: false,
      Data: toPreview.Data,
    } as IDocument);
    setisOpenPreview(true);
  };

  const handleUpload = async () => {
    try {
      await createBulkInvoices([
        ...invoiceObjects.filter(inv =>
          selectedInvoice.includes(inv.idInvoice)
        ),
      ]);
      showAlert({
        severity: 'success',
        text: 'Die Erstellung der Rechnungen war erfolgreich!',
      });
    } catch (error) {
      console.error(error);
      showAlert({
        severity: 'error',
        text: 'Die Erstellung der Rechnungen war nicht erfolgreich!',
      });
    }
    setIsOpenDialog(false);
    refetchTrigger();
  };

  return (
    <>
      <IconButton sx={{ float: 'right' }} onClick={handleOpen}>
        <Add />
      </IconButton>

      <DocumentPreviewDialog
        open={isOpenPreview}
        localDocumentObject={previewObject}
        onClose={() => setisOpenPreview(false)}
      />

      {isOpenDialog && (
        <Dialog open onClose={handleClose} maxWidth='md' fullWidth>
          <DialogContent>
            {isPending ? (
              <LoadingSpinner height='200px' />
            ) : showUploadSeciton ? (
              <InvoiceCreateDialogUpload
                setInvoiceObjects={wrapperUploadedInv}
                setShowUploadSeciton={setShowUploadSeciton}
              />
            ) : (
              <InvoiceCreateDialogSelect
                invoiceObjects={invoiceObjects}
                selectedInvoice={selectedInvoice}
                setSelectedInvoice={setSelectedInvoice}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' onClick={handleClose}>
              Abbruch
            </Button>
            <Button
              variant='contained'
              onClick={handleUpload}
              disabled={isPending || selectedInvoice.length === 0}
            >
              {isPending ? (
                <Box display='flex' alignItems='center' gap={1}>
                  <span>Erstellen</span>
                  <CircularProgress size={20} />
                </Box>
              ) : (
                'Erstellen'
              )}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
